import { gql, useQuery } from '@apollo/client'

import {
  ItemDetailBoxFragmentDoc,
  PaymentDetailFragmentDoc,
  ResaleApplicationCreateQuery,
  ResaleApplicationCreateQueryVariables,
} from '@/clients/utoniq-core/schema'
import { useRouter } from '@/core'
import { makeViewModel } from '@/core/architecture'
import { setResaleApplicationInput } from '@/core/native/storage'
import { decodeSkuId, setItemSku } from '@/core/sku'

import { Action, State } from './template'

/**
 *
 */
export const useViewModel = makeViewModel<State, Action>(() => {
  const { router, generatePath, routerPages } =
    useRouter<{ itemId: string; skuId?: string }>()
  const itemId = router.query.itemId
  const skuId = router.query?.skuId

  const { data, loading } = useQuery<
    ResaleApplicationCreateQuery,
    ResaleApplicationCreateQueryVariables
  >(QUERY, {
    variables: {
      id: itemId,
      skuId: decodeSkuId(skuId ?? '') || undefined,
    },
  })

  return {
    state: {
      loading,
      item: setItemSku(data?.item ?? null, skuId),
      cardNumber: data?.paymentSource?.last4,
      brand: data?.paymentSource?.brand ?? '',
      // 選択できる応募枚数(最大8枚まで)
      selectableItemCount:
        data?.item?.preSale?.lottery?.purchasableCount ??
        data?.item?.preSale?.firstComeFirstServed?.purchasableCount ??
        8,
    },
    actions: {
      onSubmit: async (quantity: number) => {
        await setResaleApplicationInput({
          itemCount: quantity.toString(),
          itemId,
        }).then(() => {
          router.push({
            pathname: generatePath(
              routerPages.ResaleApplicationCreateConfirmation,
              {
                itemId,
              }
            ),
            search: `${skuId ? `?skuId=${skuId}` : ''}`,
          })
        })
      },
    },
  }
})

const QUERY = gql`
  query ResaleApplicationCreate($id: ID!, $skuId: String) {
    item(id: $id) {
      ...ItemDetailBox
      preSale {
        id
        lottery {
          purchasableCount
        }
        firstComeFirstServed {
          purchasableCount
        }
      }
    }
    paymentSource {
      ...PaymentDetail
    }
  }
  ${PaymentDetailFragmentDoc}
  ${ItemDetailBoxFragmentDoc}
`
